import { useEffect, useState, useCallback, useRef } from 'react';
import classNames from 'classnames';
import Form, { Item as FormItem, GroupItem, ColCountByScreen, RequiredRule as Required, RangeRule as Range, StringLengthRule, CustomRule, PatternRule } from 'devextreme-react/form';
import { FormTextBox } from '../FormTextBox/FormTextBox';
import { FormDateBox } from '../FormDateBox/FormDateBox';
import DataGrid, { Column, Form as DataGridForm, Lookup, Toolbar, Item, Editing, Popup, RequiredRule, RangeRule, CompareRule } from 'devextreme-react/data-grid';
import { ContractPersonnel } from './ContractPersonnel';
import Button from 'devextreme-react/button';
import { Contract, TaskOrder } from '../../types/contract';
import GetFetch from '../../hooks/GetFetch';
import notify from 'devextreme/ui/notify';
 import dayjs from 'dayjs';

const URL_productCodes = '/v1/ProductCode/GetProductCodes';
const URL_productDescriptions = '/v1/ProductCode/GetProductCodeById/1';
const URL_taskOrderTypes = '/v1/TaskOrderType';
const URL_regions = '/v1/Region';
import { Endpoints } from '../../Enums/endpoints';
import { dateEditorOptions } from '../../Enums/datagridvalidations';

import './ContractForm.scss';
import { Validator } from 'devextreme-react';
import { utc } from 'moment';

const {
    GET_PRODUCT_CODE_BY_ID,
    GET_PRODUCT_CODES,
    GET_TASKORDER_TYPE
} = Endpoints;

let pdList = [];

/** @typedef {import('../../types/contract').Contract} Contract */
/** @typedef {import('../../types/contract').TaskOrder} TaskOrder */

/**
 * @param {Contract} data
 * @param {boolean} editing
 * @param {function(field, value): void} updateField
 */

export const ContractFormDetails = ({ data, editing, updateField, updateObject }) => {

    const [regions, setRegions] = useState([]);
    const [taskOrderTypes, setTaskOrderTypes] = useState([]);
    const [currentTaskOrderType, setCurrentTaskOrderType] = useState(null);
    const [modTaskOrders, setModTaskOrders] = useState([]);
    const [displayTaskOrderTypes, setDisplayTaskOrderTypes] = useState([]);
    const [productCodes, setProductCodes] = useState([]);
    const [productDescriptions, setProductDescriptions] = useState([]);
    const [isModification, setIsModification] = useState(false);
    const [modLabel, setModLabel] = useState('Modification Number');
    const [numLabel, setNumLabel] = useState('Task Order Number');
    const [formDataDefaults, setFormDataDefaults] = useState(data);
    const [popupVisible, setPopupVisible] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
    const [totalBaseTaskOrderMonths, setTotalBaseTaskOrderMonths] = useState(0);
    const gridRef = useRef(null);

    useEffect(() => {
        fetchAndSet(URL_regions, setRegions);
        fetchAndSet(URL_taskOrderTypes, setTaskOrderTypes);
        fetchAndSet(URL_productCodes, setProductCodes);
        fetchAndSet(URL_productDescriptions, setProductDescriptions);
        const modTOs = data.TaskOrders.map(taskOrder => {
            if (taskOrder.TaskOrderTypeId === 1 || taskOrder.TaskOrderTypeId === 2) {
                return taskOrder;
            }
        });
        setModTaskOrders(modTOs);
        setFormDataDefaults(data);
        setTotalBaseTaskOrderMonths(getTotalBaseTOMonths());
    }, []);

    const fetchAndSet = async (URL, setter) => {
        const { Errors, Message, Success } = await GetFetch(URL);
        if (Success === true) {
            // URL === `${GET_PRODUCT_CODE_BY_ID}1` ?
            URL == URL_productDescriptions ? setter(Message.ProductDescriptions) : setter(Message);

            if (URL === URL_taskOrderTypes)
                setDisplayTaskOrderTypes(Message);
        }
        else {
            console.error(Errors[0].Message);
        }
    }

    const renderTaskOrderForm = (e) => {
        const editItem = "Edit Task Order: " + e.row.data.Number;
        //return <a href='#' target='_self' aria-label={editItem} onClick={e => onEditTaskOrder(e)}>Edit</a>;
        return <Button onClick={onEditTaskOrder(e.row.data)}>Edit</Button>
    }

/*   const taskOrderTypeChanged = useCallback((e) => {
    const isMod = e.selectedItem.TaskOrderTypeId === 3;
    if (isMod)
      setModTaskOrders([]);
   setIsModification(isMod);
  },[isModification]); */

    const onEditorPreparing = (e) => {
        if (e.parentType === 'dataRow' && e.dataField === "Number") {
            const isModification = e.row.data.TaskOrderTypeId === 3;
            const title = isModification ? "Modification Number" : "Task Order Number";
            setNumLabel(title);
        }

        if (e.parentType === 'dataRow' && e.dataField === 'ModifyTaskOrderId') {
            const isModification = e.row.data.TaskOrderTypeId === 3;
            const title = isModification ? "Task Order Number" : "Modification Number";
            e.editorOptions.disabled = !isModification;
            setModLabel(title);
            // e.editorOptions.caption = isNotModification ? "Modification Number" : "Task Order Number";
            // const isNotModification = e.row.data.TaskOrderTypeId !== 3;
            //   e.editorOptions.dataSource = null;
            // if(isNotModification)
            //   setModTaskOrders([]);
        }

        // find the Lookup column
/*         const showBaseTaskOrder = data.TaskOrders.some((x) => 
        {
            const baseStartDate = dayjs(x.StartDate);
            const baseTimePeriod = baseStartDate.diff(x.EndDate, 'month') // 12
            return x.TaskOrderTypeId = 1 && baseTimePeriod < 12;
        }); */
        
        if (e.parentType === "dataRow" && e.dataField === "TaskOrderTypeId") {
            //e.editorOptions.onSelectionChanged = taskOrderTypeChanged;
            // change the dataSource option. You can pass a different array, or modify the existing lookup items
            e.editorOptions.dataSource = {
                store: {
                    type: "array",
                    data: taskOrderTypes
                },
                // specify postProcess
                postProcess: function (data) {
                    // Base is disabled if all base task order periods equal 1 year
                    let newData = data.map((x) => {
                        if (x.TaskOrderTypeId === 1) {
                            x.disabled = getTotalBaseTOMonths() >= 12;
                        }
                        return x;
                    });
                    return newData;
                }
            }
            // Make 'TaskOrderTypeId' read-only if the task order type is already set (e.g., not a new row)
            if (e.row.data && !e.row.isNewRow) {
                e.editorOptions.readOnly = true; // Or e.editorOptions.disabled = true;
            }
        }
    };

    const onCellPrepared = (e) => {
        let isModification = false;
        let originalTO = undefined;
        let orginalMOD = undefined;

        if(e.rowType === "data") {
            isModification = e.row.data.TaskOrderTypeId === 3;
            if (e.column.dataField === "Number") {
                originalTO = isModification ? data.TaskOrders.find(to => to.TaskOrderId === e.row.data.ModifyTaskOrderId) : undefined;
                orginalMOD = isModification ? e.row.data.Number : e.row.data.ModifyTaskOrderId;
                e.row.data.Number = isModification ? originalTO.Number : e.row.data.Number;

                // const isNotModification = e.row.data.TaskOrderTypeId !== 3;
                // const num = isNotModification ? "Task Order Number" : "Modification Number";
                // Directly set the text content of the cell element
                // e.displayValue = isModification ? e.row.data.ModifyTaskOrderId : e.row.data.Number
                //e.column.caption = num;
            }
            // if (e.rowType === 'data' && e.column.dataField === 'Number') {
            //     const isNotModification = e.row.data.TaskOrderTypeId !== 3;
            //     const num = isNotModification ? "Task Order Number" : "Modification Number";
            //     e.cellElement.outerText = num; // Change the caption/text
            // }
            if (e.column.dataField === 'ModifyTaskOrderId') {
                // let originalTO = isModification ? data.TaskOrders.find(to => to.TaskOrderId === e.row.data.ModifyTaskOrderId) : undefined;
                e.row.data.ModifyTaskOrderId = isModification ? orginalMOD : originalTO;
                // const mod = isNotModification ? "Modification Number" : "Task Order Number";
                //  e.column.caption = mod;
                // e.column.text = isNotModification ? e.row.data.ModifyTaskOrderId : e.row.data.Number;
            }
        };
    };

    function setTaskOrderType(rowData, value) {
        rowData.ModifyTaskOrderId = null;
        // if(value === 3)
        //   test1.current = [...test1.current, ...modTaskOrders];
        // else
        //   test1.current = [];
        this.defaultSetCellValue(rowData, value);
    }

    function setCellValue(newData, value, currentRowData) {
        const mod = value === 3 ? "Task Order Number" : "Modification Number";
        const num = value === 3 ? "Modification Number" : "Task Order Number";
        setModLabel(mod);
        setNumLabel(num);
        this.defaultSetCellValue(newData, value, currentRowData);
    };

    function processModTOs(itemData) {
        let result = [];

        if (formDataDefaults.TaskOrderTypeId == 3)
            result = [...result, itemData]

        return result;
    };

    const customizeItem = useCallback((formItem) => {
        if (formItem && formItem.caption === 'Modification Number') {
            const dataGridInstance = gridRef?.current.instance()
            const editing = dataGridInstance?.option('editing');
            const rowIndex = dataGridInstance?.getRowIndexByKey(editing?.editRowKey);
            const isMod = dataGridInstance?.cellValue(rowIndex, 'TaskOrderTypeId') === 3;
            formItem.disabled = !isMod;
        }
        // if (formItem && formItem.caption === 'Task Order Number') {
        //     const dataGridInstance = gridRef?.current.instance()
        //     const editing = dataGridInstance.option('editing');
        //     const rowIndex = dataGridInstance.getRowIndexByKey(editing?.editRowKey);
        //     const isMod = dataGridInstance.cellValue(rowIndex, 'TaskOrderTypeId') === 3;
        //     formItem.caption = isMod ? "Modification Number" : "Task OrderNumber";
        // }
    }, []);
    
    const getNumDisplayValue = useCallback((rowData) => {
        const originalTO = rowData.ModifyTaskOrderId ? data.TaskOrders.find(to => to.TaskOrderId === rowData.ModifyTaskOrderId).Number : undefined;
        if (rowData.TaskOrderTypeId === 3)
            return originalTO;
        else
            return rowData.Number;
    }, []);

        const getModDisplayValue = useCallback((rowData) => {
        const originalTO = rowData.ModifyTaskOrderId ? data.TaskOrders.find(to => to.TaskOrderId === rowData.ModifyTaskOrderId).Number : undefined;
        if (rowData.TaskOrderTypeId === 3)
            return rowData.Number;
        else
            return originalTO;
    }, []);

    const onFieldDataChanged = useCallback((e) => {
        if (e.dataField === "Agency" && e.value !== 'All') {
            bureauEditor.filter(["id", "=", e.value]);
            bureauEditor.load();
        }
    }, []);

    const getModTaskOrders = (options) => (
        {
            store: test1.current,
            postProcess: processModTOs
            // filter: options.data?.TaskOrderTypeId === 3 ? ["Number", "<>", 0] : null
            //  filter: (itemData) => {
            //   return options.data?.TaskOrderTypeId === 3;
            //  }
            // filter: options.data?.TaskOrderTypeId === 3 ? ["Number", "<>", 0] : ["Number", ">", "0"]
            // filter: options.data ? ["Number", "<>", 0] : null
            // options.data ? (options.data.TaskOrderTypeId === 3 ? modTaskOrders :[]) : []
            // disabled: (options.data ? (options.data.TaskOrderTypeId === 3 ? true :false) : false)
            // filter: options.data ? ['StateID', '=', options.data.StateID] : null,
        });

    const onTaskOrderInserting = (e) => {
        const hasBaseTaskOrder = data.TaskOrders.some((x) => x.TaskOrderTypeId = 1);
        // e.component.columnOption("ModifyTaskOrderId", "allowEditing", false)
        if (hasBaseTaskOrder && (e.data.taskOrderId === null || e.data.taskOrderId === undefined || e.data.taskOrderId === 0)) {
            //const updatedTaskOrderTypes = taskOrderTypes.slice(1);
            let newData = taskOrderTypes.map((x) => {
                if (x.TaskOrderTypeId === 1) {
                    x.disabled = hasBaseTaskOrder;
                }
                return x;
            });
            setDisplayTaskOrderTypes(newData);
        }
    };

  const onTaskOrderInserted = useEffect(() => {
    setDisplayTaskOrderTypes(taskOrderTypes);
  });

    const taskOrderTypeOptions = { disabled: isModification };
    const getMonthDifference = (d1, d2) => {
        let months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12; // Calculate year difference in months
        months -= d1.getMonth(); // Subtract months from the start date's year
        months += d2.getMonth(); // Add months from the end date's year
        return months;
    };

    function getAllBaseTOs() {
        let allRows = [];
        const dataGridInstance = gridRef?.current?.instance()
        const dataSource = dataGridInstance?.getDataSource();
        allRows = dataSource ? [...dataSource?.items()] : [];
        return allRows;
    }

    function getTotalBaseTOMonths() {
        let allBaseTOs = getAllBaseTOs();
        const baseTaskOrderMonths = allBaseTOs.reduce(function(acc, cur) {
            let baseTimePeriod = 0;
            if(cur.TaskOrderTypeId === 1){
                let baseEndDate = dayjs(cur.EndDate).utc();
                baseTimePeriod = Math.ceil(baseEndDate.diff(dayjs(cur.StartDate).utc(), 'month', true)) // 12
            }
            return acc + baseTimePeriod;
        }, 0);

        // var totalMonths = e.data?.EndDate ? (currentEndDate.diff(currentStartDate, "months") + totalBaseTaskOrderMonths) : totalBaseTaskOrderMonths;

        // if (formDataDefaults.TaskOrderTypeId == 3)
        //     result = [...result, itemData]

        return baseTaskOrderMonths;
    };

    const awardDateContractCompare = useCallback((e) => {
        var newDate = new Date(dayjs(e.value).utc());
        var compareDate = (formDataDefaults.AwardDate !== null && formDataDefaults.AwardDate !== undefined && formDataDefaults.AwardDate !== '')
                    ? new Date(dayjs(data.AwardDate).utc()) : new Date(dayjs(data.StartDate).utc());
         var contractEndDate = new Date(dayjs(data.EndDate).utc());    
	         return newDate >= compareDate && newDate <= contractEndDate;
     }, [data.AwardDate, data.StartDate]);

    const startDateTaskOrderCompare = useCallback((e) => {
        var newDate = new Date(dayjs(e.value).utc());
        
        var compareDate = (e.data?.AwardDate !== null && e.data?.AwardDate !== undefined && e.data?.AwardDate !== '')
            ? new Date(dayjs(e.data?.AwardDate).utc()) : new Date(dayjs(data.StartDate).utc());
        
        var contractEndDate = new Date(dayjs(data.EndDate).utc());
        var otherBaseTaskOrders = getAllBaseTOs().filter(to => to.TaskOrderTypeId === 1 && to.Number !== e.data.Number);
        var maxBaseEndDate = otherBaseTaskOrders ? Math.max(...otherBaseTaskOrders.map(to => new Date(dayjs(to.EndDate).utc()))) : undefined;
        
        const baseTaskOrderMonths = otherBaseTaskOrders.reduce(function(acc, cur) {
            let baseTimePeriod = 0;
            if(cur.TaskOrderTypeId === 1){
                let baseEndDate = dayjs(cur.EndDate).utc();
                baseTimePeriod = Math.ceil(baseEndDate.diff(dayjs(cur.StartDate).utc(), 'month', true)) // 12
            }
            return acc + baseTimePeriod;
        }, 0);

        var currentEndDate = dayjs(e.data?.EndDate).utc();
        var currentStartDate = dayjs(e.data.StartDate).utc();
        var totalMonths = e.data?.EndDate ? (Math.ceil(currentEndDate.diff(currentStartDate, "months", true)) + baseTaskOrderMonths) : baseTaskOrderMonths;
        
        return otherBaseTaskOrders?.length > 0 ? newDate >= maxBaseEndDate && newDate <= contractEndDate && totalMonths <= 12
            : newDate >= compareDate && newDate <= contractEndDate && totalMonths <= 12;
     }, [data.StartDate]);

    const endDateTaskOrderCompare = useCallback((e) => {
        var newDate = new Date(dayjs(e.value).utc());
        var taskOrderStartDate = new Date(dayjs(e.data?.StartDate).utc());        
        var contractEndDate = new Date(dayjs(data.EndDate).utc());
        var otherBaseTaskOrders = getAllBaseTOs().filter(to => to.TaskOrderTypeId === 1 && to.Number !== e.data.Number);
        
        const baseTaskOrderMonths = otherBaseTaskOrders.reduce(function(acc, cur) {
            let baseTimePeriod = 0;
            if(cur.TaskOrderTypeId === 1){
                let baseEndDate = dayjs(cur.EndDate).utc();
                baseTimePeriod = Math.ceil(baseEndDate.diff(dayjs(cur.StartDate).utc(), 'month', true)) // 12
            }
            return acc + baseTimePeriod;
        }, 0);

        var currentStartDate = dayjs(e.data.StartDate).utc();
        var currentEndDate = dayjs(e.data?.EndDate).utc();
        var totalMonths = e.data?.StartDate ? (Math.ceil(currentEndDate.diff(currentStartDate, "months", true)) + baseTaskOrderMonths) : baseTaskOrderMonths;
        
	    return newDate >= taskOrderStartDate && newDate <= contractEndDate && totalMonths <= 12;
     }, [data.EndDate]);

     const awardDateCompare = useCallback((e) => {
         var newDate = new Date(dayjs(e.value).utc());
	         var compareDate = (data?.AwardDate !== null && data?.AwardDate !== undefined && data?.AwardDate !== '')
             ? new Date(dayjs(data?.AwardDate).utc()) : new Date(dayjs(data.StartDate).utc());
         var contractEndDate = new Date(dayjs(data.EndDate).utc());
         return newDate >= compareDate && newDate <= contractEndDate;
     }, [data.EndDate]);

     const startDateCompare = useCallback((e) => {
         var newDate = new Date(dayjs(e.value).utc());
         var compareDate = (e.data?.AwardDate !== null && e.data?.AwardDate !== undefined && e.data?.AwardDate !== '')
             ? new Date(dayjs(e.data?.AwardDate).utc()) : new Date(dayjs(data.StartDate).utc());
	         var contractEndDate = new Date(dayjs(data.EndDate).utc());
         return newDate >= compareDate && newDate <= contractEndDate;
     }, [data.EndDate]);

          const endDateCompare = useCallback((e) => {
	         var newDate = new Date(dayjs(e.value).utc());
         var contractStartDate = new Date(dayjs(data?.StartDate).utc());
         return newDate >= contractStartDate;
     }, [data.EndDate]);

    const onEditTaskOrder = useCallback((e) => {
        setPopupVisible(true);
    }, []);

    const editRow = useCallback((e) => {
        const intRow = parseInt(e.element.id);
        setSelectedRowIndex(intRow);
        setPopupVisible(true);
        gridRef?.current.instance().editRow(intRow);
    }, [gridRef, selectedRowIndex]);

  const buttonRender = useCallback((e) => {
    const taskOrderId = e.data.TaskOrderId;
    const taskOrderNumber = e.data.Number;
    useEffect(() => setSelectedRowIndex(e.row.rowIndex));
    return <Button id={e.rowIndex} stylingMode='text' height={20} elementAttr={{class: 'button-link'}}
    onClick={e => editRow(e)}>{'Edit: ' + taskOrderNumber}</Button>
  }, []);

    const onAddTaskOrder = useCallback(() => {
        setPopupVisible(true);
    }, []);

    const changePopupVisibility = useCallback((isVisble) => {
        setPopupVisible(isVisble);
    }, []);

    const onDataChanged = (field, newValue) => {
        setFormDataDefaults({ ...formDataDefaults, ...{ [field]: newValue } });
        updateField(field, newValue);
    };

/*   const onEditVisible = useCallback((e) => {
    const editItem = { "aria-label": "Edit Task Order: " + e.row.data.Number };
    setEditLabel(editItem);
  }); */

    const onSaveClick = useCallback(() => {
        notify({
            message: `New contact "${newContactData.firstName} ${newContactData.lastName}" saved`,
            position: { at: 'bottom center', my: 'bottom center' }
        },
            'success'
        );
        setFormDataDefaults({ ...formDataDefaults });
        setPopupVisible(false);
    }, []);

    const onCloneIconClick = useCallback((e) => {
        const clonedItem = { ...e.row.data, ID: getMaxID() };
    });

    return (
        <Form className={classNames({ 'plain-styled-form': true, 'view-mode': !editing })}
            labelMode='floating' customizeItem={customizeItem}>
            <GroupItem colCount={4} caption='General Information' >
                <ColCountByScreen xs={4} />
                <FormItem>
                    <FormTextBox
                        label='Contract Number *'
                        value={formDataDefaults.Number}
                        isEditing={editing}
                        onValueChange={e => onDataChanged('Number', e)}>
                        <Required message='Contract Number is Required.' />
                        <PatternRule message='Contract Number must contain numbers and letters only with no spaces.' pattern={'^[a-zA-Z0-9]+$'} />
                        <StringLengthRule message='Contract Number must include 17 characters.'min={17} max={17} />
                    </FormTextBox>
                </FormItem>
                <FormItem cssClass='accent'>
                    <FormDateBox
                        name='Award Date'
                        label='Award Date'
                        value={formDataDefaults.AwardDate}
                        isEditing={editing}
                        onValueChange={e => onDataChanged('AwardDate', e)}>
                        <CustomRule message='Award Date must be equal to or greater than Contract Award Date not exceed Contract End Date.'
                            validationCallback={awardDateCompare} reevaluate={true}></CustomRule>    
                     </FormDateBox>
                </FormItem>
                <FormItem>
                    <FormDateBox
                        name='Start Date'
                        label='Start Date *'
                        value={formDataDefaults.StartDate}
                        isEditing={editing}
                        onValueChange={e => onDataChanged('StartDate', e)}
                        minValue={formDataDefaults.AwardDate ? formDataDefaults.AwardDate : undefined}
                        minName='Award Date'
                         required = {true}>
                        <CustomRule message='Start Date must be equal to or greater than Award Date and not exceed Contract End Date.'
                        validationCallback={startDateCompare} reevaluate={true}></CustomRule>
                     </FormDateBox>
                </FormItem>
                <FormItem cssClass='accent'>
                    <FormDateBox
                        name='End Date'
                        label='End Date *'
                        value={formDataDefaults.EndDate}
                        isEditing={editing}
                        onValueChange={e => onDataChanged('EndDate', e)}
                         minValue={data.StartDate}
                         minName='Start Date'
                         required = {true}>                             
                         <CustomRule message='End Date must be equal to or greather than Start Date and not exceed Contract End Date.'
                             validationCallback={endDateCompare} reevaluate={true}></CustomRule>
                     </FormDateBox>
                </FormItem>
            </GroupItem>

            <GroupItem caption='Contract Personnel'>
                <ContractPersonnel data={data.ContractPersonnel} editing={editing} updateField={updateObject} />
            </GroupItem>

            <GroupItem caption='Task Orders'>
                <DataGrid
                    id='myDataGrid'
                    dataSource={data.TaskOrders}
                    showBorders={true}
                    columnAutoWidth={true}
                    ref={gridRef}
                    key="TaskOrderId"
                    onEditorPreparing={onEditorPreparing}
                    onEditCanceled={onTaskOrderInserted}>
                    <Toolbar visible={editing} >
                        <Item name="addRowButton" showText="always" caption="Add Task Order" />
                    </Toolbar>
                    <Editing mode="popup" allowUpdating={true} allowAdding={true}  >
                        <Popup
                            showTitle={true}
                            title="Editing A Task Order"
                        />
                        <DataGridForm
                            labelLocation="top"
                            customizeItem={customizeItem}>
                            <GroupItem caption='General Information' itemType='group' colCount={2}>
                                <GroupItem itemType='group'>
                                    <FormItem dataField='TaskOrderTypeId' caption='Task Order Type' labelMode='static' elementAttr={{ class: 'form-editor' }}
                                        editorType='dxSelectBox' />
                                    <FormItem dataField='Number' label={{ text: numLabel, mode: 'static' }} elementAttr={{ class: 'form-editor' }} />
                                    <FormItem dataField='AwardDate' caption='Award Date' labelMode='static' elementAttr={{ class: 'form-editor' }}
                                        editorType="dxDateBox" editorOptions={dateEditorOptions} />
                                    <FormItem dataField='StartDate' id='StartDate' caption='Start Date' labelMode='static' elementAttr={{ class: 'form-editor' }}
                                        editorType="dxDateBox" editorOptions={dateEditorOptions} />
                                    <FormItem dataField='EndDate' caption='End Date' labelMode='static' elementAttr={{ class: 'form-editor' }}
                                        editorType="dxDateBox" editorOptions={dateEditorOptions} />
                                </GroupItem>
                                <GroupItem itemType='group'>
                                    <FormItem caption="Modification Number" label={{ text: modLabel, mode: 'static' }} dataField='ModifyTaskOrderId' editorType="dxSelectBox" elementAttr={{ class: 'form-editor' }} />
                                    <FormItem caption='Region' dataField='RegionId' labelMode='static' elementAttr={{ class: 'form-editor' }} />
                                    <FormItem caption='Vendor Name' dataField='VendorName' labelMode='static' elementAttr={{ class: 'form-editor' }} />
                                    <FormItem caption='Product Description' dataField='ProductDescriptionId' labelMode='static' elementAttr={{ class: 'form-editor' }} />
                                    <FormItem caption='Product Code' dataField='ProductCodeId' labelMode='static' elementAttr={{ class: 'form-editor' }} />
                                </GroupItem>
                            </GroupItem>
                            <GroupItem caption='Financial Codes' itemType='group' colCount={2}>
                                <GroupItem itemType='group'>
                                    <FormItem
                                        dataField='FinancialCodes.AccountCode'
                                        labelMode='static' elementAttr={{ class: 'form-editor' }}
                                        onValueChange={updateField('FinancialCodes.AccountCode')}
                                    />
                                    <FormItem
                                        dataField='FinancialCodes.AccSequenceNumber'
                                        labelMode='static' elementAttr={{ class: 'form-editor' }}
                                        onValueChange={updateField('FinancialCodes.AccSequenceNumber')}
                                    />
                                    <FormItem
                                        dataField='FinancialCodes.AccObligatedAmount' editorOptions={{ format: 'currency' }}
                                        labelMode='static' elementAttr={{ class: 'form-editor' }}
                                        onValueChange={updateField('FinancialCodes.AccObligatedAmount')}
                                    />
                                </GroupItem>
                                <GroupItem itemType='group'>
                                    <FormItem
                                        dataField='FinancialCodes.TreasuryAccSymbol'
                                        labelMode='static' elementAttr={{ class: 'form-editor' }}
                                        onValueChange={updateField('FinancialCodes.TreasuryAccSymbol')}
                                    />
                                    <FormItem
                                        dataField='FinancialCodes.CageCode'
                                        caption='Cage Code'
                                        labelMode='static' elementAttr={{ class: 'form-editor' }}
                                        onValueChange={updateField('FinancialCodes.CageCode')}
                                    />
                                    <FormItem
                                        dataField='FinancialCodes.UniqueEntityNumber'
                                        caption='UEI (Unique Entity ID Number)'
                                        labelMode='static' elementAttr={{ class: 'form-editor' }}
                                        onValueChange={updateField('FinancialCodes.UniqueEntityNumber')}
                                    />
                                </GroupItem>
                            </GroupItem>
                        </DataGridForm>
                    </Editing>
                    {/* <Column dataField="Number" name="Edit" caption="" width={50} cellRender={(e) => renderTaskOrderForm(e)} /> */}
                    <Column type='buttons' visible={editing} alignment='left' cellRender={buttonRender}>
                        {/* <Button
              name='edit'
              elementAttr={{ "aria-label": "Edit Task Order" }}
            /> */}
                    </Column>
                    <Column dataField="Number" caption="Task Order Number" calculateDisplayValue={getNumDisplayValue}>
                        <RequiredRule message="Task Order Number is required" />
                        <StringLengthRule min={2} message="Task Order Number length must be a minimum of 2 characters" />
                        <PatternRule message='Task Order Number must contain numbers and letters only with no spaces.' pattern={'^[a-zA-Z0-9]+$'} />
                    </Column>
                    <Column dataField="TaskOrderTypeId" caption="Task Order Type" setCellValue={setCellValue}>
                        <Lookup
                            dataSource={displayTaskOrderTypes}
                            displayExpr="Name"
                            valueExpr="TaskOrderTypeId"
                        />
                        <RequiredRule message="Task Order Type is required" />
                    </Column>

                    <Column dataField="ModifyTaskOrderId" caption="Modification Number" calculateDisplayValue={getModDisplayValue}>
                        <Lookup
                            dataSource={modTaskOrders}
                            displayExpr="Number"
                            valueExpr="TaskOrderId"
                        />
                    </Column>
                    <Column dataField="AwardDate" caption="Award Date" dataType='date'>
                        <CustomRule message='Award Date must be equal to or greather than Contract Award Date not exceed Contract End Date.'
                            validationCallback={awardDateContractCompare} ignoreEmptyValue={true} reevaluate={true}></CustomRule>
                    </Column>
                    <Column dataField="StartDate" caption="Start Date" dataType='date' >
                        <RequiredRule message="Start Date is required" />
                        <CustomRule message='Start Date must be equal to or greather than Award Date or Contract Start Date not exceed Contract End Date or 12 months.'
                            validationCallback={startDateTaskOrderCompare} reevaluate={true}></CustomRule>
                    </Column>
                    <Column dataField="EndDate" caption="End Date" dataType='date'>
                        <RequiredRule message="End Date is required" />
                        <CustomRule message='End Date must be equal to or greather than Start Date and not exceed Contract End Date or 12 months.'
                            validationCallback={endDateTaskOrderCompare} reevaluate={true}></CustomRule>
                    </Column>
                    <Column dataField="RegionId" caption="Region">
                        <Lookup
                            dataSource={regions}
                            displayExpr="RegionNumber"
                            valueExpr="RegionNumber"
                        />
                        <RequiredRule message="Description is required" />
                    </Column>
                    <Column dataField="VendorName" caption="Vendor Name">
                        <RequiredRule message="Vendor Name is required" />
                        <StringLengthRule min={3} message="Vendor Name must be a minimum of 3 characters" />
                    </Column>
                    <Column dataField="ProductDescriptionId" caption="Product Description">
                        <Lookup
                            dataSource={productDescriptions}
                            displayExpr="Description"
                            valueExpr="ProductDescriptionId"
                        />
                        <RequiredRule message="Description is required" />
                    </Column>
                    <Column dataField="ProductCodeId" caption="Product Code">
                        <Lookup
                            dataSource={productCodes}
                            displayExpr="Code"
                            valueExpr="ProductCodeId"
                        />
                        <RequiredRule message="Product Code is required" />
                    </Column>
                    <Column dataField="FinancialCodes.AccountCode" caption="Account Code" visible={false} />
                    <Column dataField="FinancialCodes.AccSequenceNumber" caption="Account Sequence Number" visible={false} />
                    <Column dataField="FinancialCodes.AccObligatedAmount" caption="Account Obligated Amount" visible={false} />
                    <Column dataField="FinancialCodes.TreasuryAccSymbol" caption="Treasury Account Symbol" visible={false} />
                    <Column dataField="FinancialCodes.CageCode" caption="Cage Code" visible={false} />
                    <Column dataField="FinancialCodes.UniqueEntityNumber" caption="UEI (Unique Entity ID Number)" visible={false}>
                        <StringLengthRule min={12} ignoreEmptyValue={true} message='Unique Entity Number must be a minimum length of 12' />
                    </Column>
                </DataGrid>
            </GroupItem>
        </Form>
    );
};